import AnimationController from '../../assets/js/controller/animation';
import EasingController from '../../assets/js/controller/easing';
import ResizeController from '../../assets/js/controller/resize';
import ScrollController from '../../assets/js/controller/scroll';

import { bindEvents, clamp, getRootOffsetBounds, mq } from '../../assets/js/helpers';

const selector = 'image';

export default class Image {

	constructor(section) {
		this.el = {
			section,
			img: section.querySelector('img'),
			parallaxWrapper: section.querySelector(`.${selector}__parallax-wrapper`)
		};

		// class variable groups

		this.config = {
			maxScale: 1.2,
			transformOriginY: 0.7 // transform-origin y ratio
		};

		this.controllers = {
			animation: null,
			resize: null,
			scroll: null
		};

		this.coords = {
			section: null,
			maxShift: 0 // dynamically calculated by max scale
		};

		this.flags = {
			isManual: false,
			isParallax: false
		};

		this.states = {};

		// class variable singles

		this.easeOut = EasingController.ease(EasingController.curves.easeOut);

		// bind events to class scope
		this.events = bindEvents(this);

		// let's mosey
		this.init();
	}

	static get selector() {
		return selector;
	}

	// initialize

	init() {

		if (this.el.section.hasAttribute('data-image-parallax-manual')) {
			this.flags.isManual = true;
		}

		if (this.el.section.hasAttribute('data-image-parallax')) {
			const scaleAttribute = parseFloat(this.el.section.getAttribute('data-image-parallax'));
			this.config.maxScale = !isNaN(scaleAttribute) ? scaleAttribute : this.config.maxScale;
		}

		if (this.el.section.hasAttribute('data-image-parallax')) {
			this.flags.isParallax = true;
		}

		this.addEventListeners();
	}

	// event listeners

	addEventListeners() {
		if (!this.controllers.resize) {
			this.controllers.resize = ResizeController.set({
				update: () => true,
				render: () => {
					this.measureResize();
				}
			});
		}

		if (mq('medium')) {
			this.measureResize();
		}
	}

	removeEventListeners() {
		if (this.controllers.resize) {
			ResizeController.clear(this.controllers.resize);
			this.controllers.resize = null;
		}

		this.removeScrollListener();
	}

	// listener methods

	_onWindowResize() {
		this.measureResize();
	}

	measureResize() {
		if (mq('medium')) {
			this.coords.section = getRootOffsetBounds(this.el.section);
			this.coords.maxShift = this.coords.section.height * (this.config.maxScale - 1);
			this.addScrollListener();
		} else {
			this.resetParallax();
			this.removeScrollListener();
		}
	}

	//

	addScrollListener() {
		if (this.flags.isParallax && !this.flags.isManual) {
			if (!this.controllers.animation) {
				AnimationController.set({
					update: () => true,
					render: () => {
						this.renderScroll();
					}
				});
			}
		}
	}

	removeScrollListener() {
		if (this.controllers.animation) {
			AnimationController.clear(this.controllers.animation);
			this.controllers.animation = null;
		}
	}

	//

	renderScroll(manualCenterY = null) {
		if (manualCenterY || (this.coords.section && this.coords.section.centerY)) {
			const centerY = !isNaN(parseFloat(manualCenterY)) ? manualCenterY : this.coords.section.centerY;
			const centerRatio = this.easeOut(clamp((ScrollController.position + window.innerHeight / 4 * 3 - centerY) / (window.innerHeight), -1, 1));
			const shiftY = (1 - centerRatio) / 2 * this.coords.maxShift * this.config.transformOriginY;
			const scale = (1 - centerRatio) / 2 * (this.config.maxScale - 1) + 1;
			this.el.parallaxWrapper.style.transform = `translateY(${shiftY}px) scale(${scale})`;
		}
	}

	resetParallax() {
		this.el.parallaxWrapper.style.transform = '';
	}

	// destroy

	destroy() {
		this.removeEventListeners();
	}

}
